export default {
    data() {
        return {
            id: '',
            searchParams: {},
            loading: false,
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            totalData: [],
            selected: []
        };
    },
    methods: {
        // 查询
        queryList() {
            const params = Object.assign({ pageNo: this.pageNo, pageSize: this.pageSize }, this.searchParams);
            const successCallback = (res) => {
                const data = res.data || res || {};
                this.totalData = data.list || [];
                this.pageTotal = data.totalCount || 0;
            };
            this.queryListExecute && this.queryListExecute({ params, successCallback });
        },
        // 分页
        handlePageChange(data) {
            this.pageNo = data;
            this.queryList();
        },
        // 分页大小
        handleSizeChange(data) {
            this.pageSize = data;
            this.queryList();
        },
        // 搜索
        handleSearchChange(data) {
            this.searchParams = data;
            this.pageNo = 1;
            this.queryList();
        },
        // 双击表格
        handleRowDBClick(row) {
            this.id = String(row.id);
            this.rowDBClickExecute && this.rowDBClickExecute(row);
        },
        // 多选
        handleSelectChange(data) {
            this.selected = [].concat(data);
        },
        // 启用
        handleStartUsing() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else {
                const confirmFn = () => this.$confirm('是否确认启用？', '启用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                });
                const successCallback = () => {
                    this.$message.success('已启用');
                    this.queryList();
                };
                this.startUsingExecute && this.startUsingExecute({ confirmFn, params: { selected: this.selected }, successCallback });
            }
        },
        // 停用
        handleStopUsing() {
            if (this.selected.length === 0) {
                this.$message.warning('当前没有选中的数据');
            } else if (this.selected.length > 1) {
                this.$message.warning('当前只能操作一条数据！');
            } else {
                const confirmFn = () => this.$confirm('是否确认停用？', '停用确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                });
                const successCallback = () => {
                    this.$message.success('已停用');
                    this.queryList();
                };
                this.stopUsingExecute && this.stopUsingExecute({ confirmFn, params: { selected: this.selected }, successCallback });
            }
        },
        // 新增
        handleAdd() {
            this.$refs.tablePage.$refs.table.addRow();
        },
        // 保存
        handleSave() {
            if (this.selected.length !== 1) {
                return this.$message.warning('请选择一条数据');
            }
            if (!this.$refs.tablePage.$refs.table.$refs.mNewTable.saveData()) {
                return false;
            }
            const successCallback = () => {
                this.$message.success('保存成功');
                this.selected = [];
                this.queryList();
            };
            this.saveTableExecute && this.saveTableExecute({ params: { selected: this.selected }, successCallback });
        },
        // 保存-多个
        handleSaves() {
            if (!this.selected.length) {
                this.$message.warning('请勾选数据');
                return;
            }
            if (!this.$refs.tablePage.$refs.table.$refs.mNewTable.saveData()) {
                return false;
            }
            const successCallback = () => {
                this.$message.success('保存成功');
                this.selected = [];
                this.queryList();
            };
            this.saveTableExecute && this.saveTableExecute({ params: { selected: this.selected }, successCallback });
        },
        // 删除
        handleDelete() {
            if (!this.selected.length) {
                this.$message.warning('请勾选数据');
                return;
            }
            const confirmFn = () => this.$confirm('您确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
            const successCallback = () => {
                this.$message.success('删除成功');
                this.selected = [];
                this.pageNo = 1;
                this.queryList();
            };
            const ids = [];
            this.selected.forEach(li => { li.id && ids.push(li.id); });
            if (!ids.length) {
                return this.$message.warning('请选择已有的数据');
            }
            this.deleteTableConfirmExecute && this.deleteTableConfirmExecute({ confirmFn, params: { selected: this.selected, ids }, successCallback });
        }
    },
    created() {
        this.queryList();
    }
};